"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[810],{

/***/ 37468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "or": function() { return /* reexport */ CustomerTabCredit_reducer; },
  "UK": function() { return /* reexport */ requestCustomerTabCreditsInfo; },
  "XZ": function() { return /* reexport */ selectAllCustomerTabCreditsInfo; },
  "w6": function() { return /* reexport */ selectAreCustomerTabCreditsLoaded; },
  "e8": function() { return /* reexport */ selectTotalCustomerTabCredit; },
  "I$": function() { return /* reexport */ CustomerTabCreditsWatcher; }
});

// UNUSED EXPORTS: ApiCustomerTabCreditAggregate, ApiCustomerTabCreditField, failedCustomerTabCreditsInfo, succeededCustomerTabCreditsInfo

// EXTERNAL MODULE: ./src/modules/Reports/helpers.ts
var helpers = __webpack_require__(43549);
;// CONCATENATED MODULE: ./src/modules/CustomerTabCredit/reducer.ts

const { reducer , actions  } = (0,helpers/* createReportReducer */.jH)("CustomerTabCredits");
const { failed: failedCustomerTabCreditsInfo , request: requestCustomerTabCreditsInfo , succeeded: succeededCustomerTabCreditsInfo ,  } = actions;
/* harmony default export */ var CustomerTabCredit_reducer = (reducer);

// EXTERNAL MODULE: ./node_modules/redux-saga/dist/redux-saga-effects-npm-proxy.esm.js + 1 modules
var redux_saga_effects_npm_proxy_esm = __webpack_require__(66699);
// EXTERNAL MODULE: ./src/errors/index.ts + 10 modules
var errors = __webpack_require__(62640);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/modules/Reports/index.ts + 7 modules
var Reports = __webpack_require__(86922);
;// CONCATENATED MODULE: ./src/modules/CustomerTabCredit/types/api.ts
var ApiCustomerTabCreditField;
(function(ApiCustomerTabCreditField) {
    ApiCustomerTabCreditField["CreditType"] = "credit_type";
    ApiCustomerTabCreditField["SumCreditAmount"] = "sum_credit_amount";
    ApiCustomerTabCreditField["SumCreditCount"] = "sum_credit_count";
})(ApiCustomerTabCreditField || (ApiCustomerTabCreditField = {}));
var ApiCustomerTabCreditAggregate;
(function(ApiCustomerTabCreditAggregate) {
    ApiCustomerTabCreditAggregate["PaymentMethod"] = "paymentMethod";
})(ApiCustomerTabCreditAggregate || (ApiCustomerTabCreditAggregate = {}));

;// CONCATENATED MODULE: ./src/modules/CustomerTabCredit/types/index.ts



;// CONCATENATED MODULE: ./src/modules/CustomerTabCredit/services.ts




const mapApiDataToCustomerTabCreditInfo = (apiData)=>({
        creditType: String(apiData[ApiCustomerTabCreditField.CreditType]),
        sumCreditAmount: Number(apiData[ApiCustomerTabCreditField.SumCreditAmount]),
        sumCreditCount: Number(apiData[ApiCustomerTabCreditField.SumCreditCount])
    });
const getCustomerTabCreditsPerStoreAsync = async (query)=>(0,Reports/* getEntitiesPerStoreAsync */.cM)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query), {
        aggregates: [
            ApiCustomerTabCreditAggregate.PaymentMethod
        ],
        resource: Reports/* ReportResource.TillCustomerTabCredit */.Hh.TillCustomerTabCredit
    }), mapApiDataToCustomerTabCreditInfo);

;// CONCATENATED MODULE: ./src/modules/CustomerTabCredit/sagas.ts




function* getCustomerTabCreditsSaga(param) {
    let { payload: query  } = param;
    try {
        const result = yield (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(getCustomerTabCreditsPerStoreAsync, query);
        yield (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(succeededCustomerTabCreditsInfo(result));
    } catch (e) {
        yield (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(failedCustomerTabCreditsInfo({
            storeIds: query.storeIds,
            error: (0,errors/* createError */.Tr)(e)
        }));
    }
}
function* CustomerTabCreditsWatcher() {
    yield (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(requestCustomerTabCreditsInfo.type, getCustomerTabCreditsSaga);
};

// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./src/types/index.ts + 1 modules
var types = __webpack_require__(87202);
// EXTERNAL MODULE: ./src/modules/Preferences/index.ts + 3 modules
var Preferences = __webpack_require__(46445);
;// CONCATENATED MODULE: ./src/modules/CustomerTabCredit/helpers.ts
/**
 * Compare 2 CustomerTabCredits only by amount and payment method for sorting
 *
 * @param CustomerTabCreditA CustomerTabCredit to use for compare
 * @param CustomerTabCreditB CustomerTabCredit to compare againt
 */ const compareCustomerTabCredits = (CustomerTabCreditA, CustomerTabCreditB)=>{
    const sumCreditAmountA = CustomerTabCreditA.sumCreditAmount;
    const sumCreditAmountB = CustomerTabCreditB.sumCreditAmount;
    if (sumCreditAmountA > sumCreditAmountB) {
        return 1;
    }
    if (sumCreditAmountA < sumCreditAmountB) {
        return -1;
    }
    const sumCreditCountA = CustomerTabCreditA.sumCreditCount;
    const sumCreditCountB = CustomerTabCreditB.sumCreditCount;
    if (sumCreditCountA > sumCreditCountB) {
        return 1;
    }
    if (sumCreditCountA < sumCreditCountB) {
        return -1;
    }
    return 0;
};

;// CONCATENATED MODULE: ./src/modules/CustomerTabCredit/selectors.ts







/**
 * Get all CustomerTabCredits organized per store
 */ const selectAllCustomerTabCreditsPerStore = (param)=>{
    let { CustomerTabCredits  } = param;
    return CustomerTabCredits;
};
/**
 * Check if all CustomerTabCredits are loaded
 */ const selectAreCustomerTabCreditsLoaded = (0,es/* createSelector */.P1)(selectAllCustomerTabCreditsPerStore, (CustomerTabCreditsPerStore)=>!(0,lodash.isEmpty)(CustomerTabCreditsPerStore) && (0,lodash.every)(CustomerTabCreditsPerStore, (CustomerTabCredit)=>CustomerTabCredit.status === types/* Status.SUCCEEDED */.q.SUCCEEDED || CustomerTabCredit.status === types/* Status.FAILED */.q.FAILED));
/**
 * Get all CustomerTabCredits organised by categories name
 */ const selectAllCustomerTabCreditsInfo = (0,es/* createSelector */.P1)(selectAllCustomerTabCreditsPerStore, Preferences/* getSelectedStoresIds */.F, (CustomerTabCreditsPerStore, storeIds)=>{
    const allCustomerTabCredits = (0,lodash.reduce)(CustomerTabCreditsPerStore, (globalCustomerTabCredits, CustomerTabCredit, storeId)=>{
        if (!(storeIds === null || storeIds === void 0 ? void 0 : storeIds.includes(Number(storeId))) || CustomerTabCredit.status !== types/* Status.SUCCEEDED */.q.SUCCEEDED) {
            return globalCustomerTabCredits;
        }
        (0,lodash.forEach)(CustomerTabCredit.entities, (CustomerTabCreditDetail)=>{
            const category = CustomerTabCreditDetail.creditType;
            if (!globalCustomerTabCredits[category]) {
                globalCustomerTabCredits[category] = CustomerTabCreditDetail;
            } else {
                const globalCustomerTabCredit = globalCustomerTabCredits[category];
                globalCustomerTabCredits[category] = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, globalCustomerTabCredit), {
                    sumCreditCount: globalCustomerTabCredit.sumCreditCount + CustomerTabCreditDetail.sumCreditCount
                });
            }
            return globalCustomerTabCredits;
        });
        return globalCustomerTabCredits;
    }, {});
    return Object.values(allCustomerTabCredits).sort(compareCustomerTabCredits);
});
const selectTotalCustomerTabCredit = (0,es/* createSelector */.P1)(selectAllCustomerTabCreditsInfo, (customerTabCreditInfo)=>customerTabCreditInfo.reduce((acc, curr)=>acc + curr.sumCreditAmount, 0));

;// CONCATENATED MODULE: ./src/modules/CustomerTabCredit/index.ts
/**
 * CustomerTabCredit module
 */ /* Actions */ 
/* Reducer */ 
/* Sagas */ 
/* Selectors */ 
/* Types */ 


/***/ }),

/***/ 85628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "oc": function() { return /* reexport */ Expenses_reducer; },
  "yY": function() { return /* reexport */ requestExpensesInfo; },
  "as": function() { return /* reexport */ selectAllExpensesInfo; },
  "tU": function() { return /* reexport */ selectAreExpensesLoaded; },
  "v8": function() { return /* reexport */ selectSelectedStoresTotalExpenses; },
  "DV": function() { return /* reexport */ expensesWatcher; }
});

// UNUSED EXPORTS: ApiExpensesAggregate, ApiExpensesField, failedExpensesInfo, succeededExpensesInfo

// EXTERNAL MODULE: ./src/modules/Reports/helpers.ts
var helpers = __webpack_require__(43549);
;// CONCATENATED MODULE: ./src/modules/Expenses/reducer.ts

const { reducer , actions  } = (0,helpers/* createReportReducer */.jH)("expenses");
const { failed: failedExpensesInfo , request: requestExpensesInfo , succeeded: succeededExpensesInfo ,  } = actions;
/* harmony default export */ var Expenses_reducer = (reducer);

// EXTERNAL MODULE: ./node_modules/redux-saga/dist/redux-saga-effects-npm-proxy.esm.js + 1 modules
var redux_saga_effects_npm_proxy_esm = __webpack_require__(66699);
// EXTERNAL MODULE: ./src/errors/index.ts + 10 modules
var errors = __webpack_require__(62640);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/modules/Reports/index.ts + 7 modules
var Reports = __webpack_require__(86922);
;// CONCATENATED MODULE: ./src/modules/Expenses/types/api.ts
var ApiExpensesField;
(function(ApiExpensesField) {
    ApiExpensesField["ExpenseLabel"] = "expense_label";
    ApiExpensesField["ExpensePaymentType"] = "expense_payment_type";
    ApiExpensesField["NbExpenses"] = "nb_expenses";
    ApiExpensesField["SumExpenseTaxAmount"] = "sum_expense_tax_amount";
    ApiExpensesField["SumExpenseTaxExcluded"] = "sum_expense_tax_excluded";
    ApiExpensesField["SumExpenseTaxIncluded"] = "sum_expense_tax_included";
})(ApiExpensesField || (ApiExpensesField = {}));
var ApiExpensesAggregate;
(function(ApiExpensesAggregate) {
    ApiExpensesAggregate["Label"] = "label";
    ApiExpensesAggregate["PaymentType"] = "paymentType";
})(ApiExpensesAggregate || (ApiExpensesAggregate = {}));

;// CONCATENATED MODULE: ./src/modules/Expenses/types/index.ts



;// CONCATENATED MODULE: ./src/modules/Expenses/services.ts




const mapApiDataToExpenseInfo = (apiData)=>({
        amountExclTax: Number(apiData[ApiExpensesField.SumExpenseTaxExcluded]),
        amountInclTax: Number(apiData[ApiExpensesField.SumExpenseTaxIncluded]),
        amountTax: Number(apiData[ApiExpensesField.SumExpenseTaxAmount]),
        nbPayments: Number(apiData[ApiExpensesField.NbExpenses]),
        paymentMethod: String(apiData[ApiExpensesField.ExpensePaymentType]),
        reason: String(apiData[ApiExpensesField.ExpenseLabel])
    });
const getExpensesPerStoreAsync = async (query)=>(0,Reports/* getEntitiesPerStoreAsync */.cM)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query), {
        resource: Reports/* ReportResource.Expenses */.Hh.Expenses,
        aggregates: [
            ApiExpensesAggregate.Label,
            ApiExpensesAggregate.PaymentType
        ],
        closedTillLimitation: true
    }), mapApiDataToExpenseInfo);

;// CONCATENATED MODULE: ./src/modules/Expenses/sagas.ts




function* getExpensesSaga(param) {
    let { payload: query  } = param;
    try {
        const result = yield (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(getExpensesPerStoreAsync, query);
        yield (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(succeededExpensesInfo(result));
    } catch (e) {
        yield (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(failedExpensesInfo({
            storeIds: query.storeIds,
            error: (0,errors/* createError */.Tr)(e)
        }));
    }
}
function* expensesWatcher() {
    yield (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(requestExpensesInfo.type, getExpensesSaga);
};

// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./src/types/index.ts + 1 modules
var types = __webpack_require__(87202);
// EXTERNAL MODULE: ./src/modules/Preferences/index.ts + 3 modules
var Preferences = __webpack_require__(46445);
;// CONCATENATED MODULE: ./src/modules/Expenses/helpers.ts
/**
 * Compare 2 expenses only by reason and payment method for sorting
 *
 * @param expenseA expense to use for compare
 * @param expenseB expense to compare againt
 */ const compareExpenses = (expenseA, expenseB)=>{
    const expenseReasonA = expenseA.reason;
    const expenseReasonB = expenseB.reason;
    if (expenseReasonA > expenseReasonB) {
        return 1;
    }
    if (expenseReasonA < expenseReasonB) {
        return -1;
    }
    const paymentMethodA = expenseA.paymentMethod;
    const paymentMethodB = expenseB.paymentMethod;
    if (paymentMethodA > paymentMethodB) {
        return 1;
    }
    if (paymentMethodA < paymentMethodB) {
        return -1;
    }
    return 0;
};

;// CONCATENATED MODULE: ./src/modules/Expenses/selectors.ts







/**
 * Get all expenses organized per store
 */ const selectAllExpensesPerStore = (param)=>{
    let { expenses  } = param;
    return expenses;
};
/**
 * Check if all expenses are loaded
 */ const selectAreExpensesLoaded = (0,es/* createSelector */.P1)(selectAllExpensesPerStore, (expensesPerStore)=>!(0,lodash.isEmpty)(expensesPerStore) && (0,lodash.every)(expensesPerStore, (expenses)=>expenses.status === types/* Status.SUCCEEDED */.q.SUCCEEDED || expenses.status === types/* Status.FAILED */.q.FAILED));
/**
 * Get all expenses organised by categories name
 */ const selectAllExpensesInfo = (0,es/* createSelector */.P1)(selectAllExpensesPerStore, Preferences/* getSelectedStoresIds */.F, (expensesPerStore, storeIds)=>{
    const allExpenses = (0,lodash.reduce)(expensesPerStore, (globalExpenses, expenses, storeId)=>{
        if (!(storeIds === null || storeIds === void 0 ? void 0 : storeIds.includes(Number(storeId))) || expenses.status !== types/* Status.SUCCEEDED */.q.SUCCEEDED) {
            return globalExpenses;
        }
        (0,lodash.forEach)(expenses.entities, (expense)=>{
            const category = "".concat(expense.reason).concat(expense.paymentMethod);
            if (!globalExpenses[category]) {
                globalExpenses[category] = expense;
            } else {
                const globalExpense = globalExpenses[category];
                globalExpenses[category] = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, globalExpense), {
                    amountExclTax: globalExpense.amountExclTax + expense.amountExclTax,
                    amountInclTax: globalExpense.amountInclTax + expense.amountInclTax,
                    amountTax: globalExpense.amountTax + expense.amountTax,
                    nbPayments: globalExpense.nbPayments + expense.nbPayments
                });
            }
            return globalExpenses;
        });
        return globalExpenses;
    }, {});
    return Object.values(allExpenses).sort(compareExpenses);
});
const selectSelectedStoresTotalExpenses = (0,es/* createSelector */.P1)(selectAllExpensesInfo, (expenses)=>expenses.reduce((acc, curr)=>acc + curr.amountInclTax, 0));

;// CONCATENATED MODULE: ./src/modules/Expenses/index.ts






/***/ }),

/***/ 83531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AO": function() { return /* reexport */ Payments_reducer; },
  "r4": function() { return /* reexport */ requestPaymentsInfo; },
  "SG": function() { return /* reexport */ selectAllPaymentsInfo; },
  "rA": function() { return /* reexport */ selectArePaymentsLoaded; },
  "dK": function() { return /* reexport */ selectSelectedStoresTotalPayments; },
  "cC": function() { return /* reexport */ paymentsWatcher; }
});

// UNUSED EXPORTS: ApiPaymentsAggregate, ApiPaymentsField, failedPaymentsInfo, succeededPaymentsInfo

// EXTERNAL MODULE: ./src/modules/Reports/helpers.ts
var helpers = __webpack_require__(43549);
;// CONCATENATED MODULE: ./src/modules/Payments/reducer.ts

const { reducer , actions  } = (0,helpers/* createReportReducer */.jH)("payments");
const { failed: failedPaymentsInfo , request: requestPaymentsInfo , succeeded: succeededPaymentsInfo ,  } = actions;
/* harmony default export */ var Payments_reducer = (reducer);

// EXTERNAL MODULE: ./node_modules/redux-saga/dist/redux-saga-effects-npm-proxy.esm.js + 1 modules
var redux_saga_effects_npm_proxy_esm = __webpack_require__(66699);
// EXTERNAL MODULE: ./src/errors/index.ts + 10 modules
var errors = __webpack_require__(62640);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/modules/Reports/index.ts + 7 modules
var Reports = __webpack_require__(86922);
;// CONCATENATED MODULE: ./src/modules/Payments/types/api.ts
var ApiPaymentsField;
(function(ApiPaymentsField) {
    ApiPaymentsField["CashbackAmount"] = "cashback_amount";
    ApiPaymentsField["CashbackCount"] = "cashback_count";
    ApiPaymentsField["PaymentAmount"] = "sum_payment_amount";
    ApiPaymentsField["PaymentAmountNoCashback"] = "payment_amount_no_cashback";
    ApiPaymentsField["PaymentCount"] = "sum_payment_count";
    ApiPaymentsField["PaymentCountNoCashback"] = "payment_count_no_cashback";
    ApiPaymentsField["PaymentMethod"] = "payment_label";
})(ApiPaymentsField || (ApiPaymentsField = {}));
var ApiPaymentsAggregate;
(function(ApiPaymentsAggregate) {
    ApiPaymentsAggregate["PaymentMethod"] = "paymentLabel";
})(ApiPaymentsAggregate || (ApiPaymentsAggregate = {}));

;// CONCATENATED MODULE: ./src/modules/Payments/types/index.ts



;// CONCATENATED MODULE: ./src/modules/Payments/services.ts




const mapApiDataToPaymentInfo = (apiData)=>({
        amount: Number(apiData[ApiPaymentsField.PaymentAmount]),
        nbPayments: Number(apiData[ApiPaymentsField.PaymentCount]),
        paymentMethod: String(apiData[ApiPaymentsField.PaymentMethod]),
        cashbackCount: Number(apiData[ApiPaymentsField.CashbackCount]),
        cashbackAmount: Number(apiData[ApiPaymentsField.CashbackAmount]),
        amountNoCashback: Number(apiData[ApiPaymentsField.PaymentAmountNoCashback]),
        countNoCashback: Number(apiData[ApiPaymentsField.PaymentCountNoCashback])
    });
const getPaymentsPerStoreAsync = async (query)=>(0,Reports/* getEntitiesPerStoreAsync */.cM)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query), {
        resource: Reports/* ReportResource.Payments */.Hh.Payments,
        aggregates: [
            ApiPaymentsAggregate.PaymentMethod
        ],
        closedTillLimitation: true
    }), mapApiDataToPaymentInfo);

;// CONCATENATED MODULE: ./src/modules/Payments/sagas.ts




function* getPaymentsSaga(param) {
    let { payload: query  } = param;
    try {
        const result = yield (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(getPaymentsPerStoreAsync, query);
        yield (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(succeededPaymentsInfo(result));
    } catch (e) {
        yield (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(failedPaymentsInfo({
            storeIds: query.storeIds,
            error: (0,errors/* createError */.Tr)(e)
        }));
    }
}
function* paymentsWatcher() {
    yield (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(requestPaymentsInfo.type, getPaymentsSaga);
};

// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./src/types/index.ts + 1 modules
var types = __webpack_require__(87202);
// EXTERNAL MODULE: ./src/modules/Preferences/index.ts + 3 modules
var Preferences = __webpack_require__(46445);
;// CONCATENATED MODULE: ./src/modules/Payments/helpers.ts
/**
 * Compare 2 payments by amount and payment method for sorting
 *
 * @param paymentA payment to use for compare
 * @param paymentB payment to compare againt
 */ const comparePayments = (paymentA, paymentB)=>{
    const paymentAmountA = paymentA.amount;
    const paymentAmountB = paymentB.amount;
    if (paymentAmountA > paymentAmountB) {
        return 1;
    }
    if (paymentAmountA < paymentAmountB) {
        return -1;
    }
    const paymentMethodA = paymentA.paymentMethod;
    const paymentMethodB = paymentB.paymentMethod;
    if (paymentMethodA > paymentMethodB) {
        return 1;
    }
    if (paymentMethodA < paymentMethodB) {
        return -1;
    }
    return 0;
};

;// CONCATENATED MODULE: ./src/modules/Payments/selectors.ts







/**
 * Get all payments organized per store
 */ const selectAllPaymentsPerStore = (param)=>{
    let { payments  } = param;
    return payments;
};
/**
 * Check if all payments are loaded
 */ const selectArePaymentsLoaded = (0,es/* createSelector */.P1)(selectAllPaymentsPerStore, (paymentsPerStore)=>!(0,lodash.isEmpty)(paymentsPerStore) && (0,lodash.every)(paymentsPerStore, (payments)=>payments.status === types/* Status.SUCCEEDED */.q.SUCCEEDED || payments.status === types/* Status.FAILED */.q.FAILED));
/**
 * Get all payments organised by categories name
 */ const selectAllPaymentsInfo = (0,es/* createSelector */.P1)(selectAllPaymentsPerStore, Preferences/* getSelectedStoresIds */.F, (paymentsPerStore, storeIds)=>{
    const allPayments = (0,lodash.reduce)(paymentsPerStore, (globalPayments, payments, storeId)=>{
        if (!(storeIds === null || storeIds === void 0 ? void 0 : storeIds.includes(Number(storeId))) || payments.status !== types/* Status.SUCCEEDED */.q.SUCCEEDED) {
            return globalPayments;
        }
        (0,lodash.forEach)(payments.entities, (payment)=>{
            const category = payment.paymentMethod;
            if (!globalPayments[category]) {
                globalPayments[category] = payment;
            } else {
                const globalPayment = globalPayments[category];
                globalPayments[category] = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, globalPayment), {
                    amount: globalPayment.amount + payment.amount,
                    countNoCashback: globalPayment.countNoCashback + payment.countNoCashback
                });
            }
            return globalPayments;
        });
        return globalPayments;
    }, {});
    return Object.values(allPayments).sort(comparePayments);
});
const selectSelectedStoresTotalPayments = (0,es/* createSelector */.P1)(selectAllPaymentsInfo, (paymentInfo)=>paymentInfo.reduce((acc, curr)=>acc + curr.amount, 0));

;// CONCATENATED MODULE: ./src/modules/Payments/index.ts
/**
 * Payments module
 */ /* Actions */ 
/* Reducer */ 
/* Sagas */ 
/* Selectors */ 
/* Types */ 


/***/ }),

/***/ 29264:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "El": function() { return /* reexport */ Taxes_reducer; },
  "sr": function() { return /* reexport */ requestTaxesInfo; },
  "pu": function() { return /* reexport */ selectAllTaxesInfo; },
  "km": function() { return /* reexport */ selectAreTaxesLoaded; },
  "wN": function() { return /* reexport */ taxesWatcher; }
});

// UNUSED EXPORTS: ApiOrderProductsAggregate, ApiOrderProductsField, failedTaxesInfo, succeededTaxesInfo

// EXTERNAL MODULE: ./src/modules/Reports/helpers.ts
var helpers = __webpack_require__(43549);
;// CONCATENATED MODULE: ./src/modules/Taxes/reducer.ts

const { reducer , actions  } = (0,helpers/* createReportReducer */.jH)("taxes");
const { failed: failedTaxesInfo , request: requestTaxesInfo , succeeded: succeededTaxesInfo ,  } = actions;
/* harmony default export */ var Taxes_reducer = (reducer);

// EXTERNAL MODULE: ./node_modules/redux-saga/dist/redux-saga-effects-npm-proxy.esm.js + 1 modules
var redux_saga_effects_npm_proxy_esm = __webpack_require__(66699);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/modules/Reports/index.ts + 7 modules
var Reports = __webpack_require__(86922);
;// CONCATENATED MODULE: ./src/modules/Taxes/types/api.ts
var ApiOrderProductsField;
(function(ApiOrderProductsField) {
    ApiOrderProductsField["LineTaxRate"] = "line_tax_rate";
    ApiOrderProductsField["ProductType"] = "product_type";
    ApiOrderProductsField["SumLinePriceTaxExcluded"] = "sum_line_price_tax_excluded";
    ApiOrderProductsField["SumLinePriceTaxIncluded"] = "sum_line_price_tax_included";
    ApiOrderProductsField["SumLineTaxAmount"] = "sum_line_tax_amount";
})(ApiOrderProductsField || (ApiOrderProductsField = {}));
var ApiOrderProductsAggregate;
(function(ApiOrderProductsAggregate) {
    ApiOrderProductsAggregate["ProductType"] = "productType";
    ApiOrderProductsAggregate["TaxRate"] = "taxRate";
})(ApiOrderProductsAggregate || (ApiOrderProductsAggregate = {}));

;// CONCATENATED MODULE: ./src/modules/Taxes/types/index.ts



;// CONCATENATED MODULE: ./src/modules/Taxes/services.ts




const parseApiDataToTaxInfo = (apiData)=>({
        vat: Number(apiData[ApiOrderProductsField.SumLineTaxAmount]),
        name: String(apiData[ApiOrderProductsField.LineTaxRate] || ""),
        salesInclTax: Number(apiData[ApiOrderProductsField.SumLinePriceTaxIncluded]),
        salesExclTax: Number(apiData[ApiOrderProductsField.SumLinePriceTaxExcluded]),
        productType: String(apiData[ApiOrderProductsField.ProductType])
    });
const getTaxesPerStoreAsync = async (query)=>(0,Reports/* getEntitiesPerStoreAsync */.cM)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query), {
        resource: Reports/* ReportResource.OrderProducts */.Hh.OrderProducts,
        aggregates: [
            ApiOrderProductsAggregate.TaxRate,
            ApiOrderProductsAggregate.ProductType
        ],
        closedTillLimitation: true
    }), parseApiDataToTaxInfo);

;// CONCATENATED MODULE: ./src/modules/Taxes/sagas.ts



function* getTaxesSaga(param) {
    let { payload: query  } = param;
    try {
        const result = yield (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(getTaxesPerStoreAsync, query);
        yield (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(succeededTaxesInfo(result));
    } catch (e) {
        yield (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(failedTaxesInfo({
            storeIds: query.storeIds,
            error: e
        }));
    }
}
function* taxesWatcher() {
    yield (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(requestTaxesInfo.type, getTaxesSaga);
};

// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./src/types/index.ts + 1 modules
var types = __webpack_require__(87202);
// EXTERNAL MODULE: ./src/modules/Preferences/index.ts + 3 modules
var Preferences = __webpack_require__(46445);
;// CONCATENATED MODULE: ./src/modules/Taxes/helpers.ts
const compareTaxes = (taxA, taxB)=>{
    var ref, ref1;
    const taxNameA = Number.parseInt(taxA.name, 10);
    const taxNameB = Number.parseInt(taxB.name, 10);
    if (taxNameA > taxNameB) {
        return 1;
    }
    if (taxNameA < taxNameB) {
        return -1;
    }
    const productTypeA = ((ref = taxA.productType) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || "";
    const productTypeB = ((ref1 = taxB.productType) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) || "";
    if (productTypeA > productTypeB) {
        return 1;
    }
    if (productTypeA < productTypeB) {
        return -1;
    }
    return 0;
};

;// CONCATENATED MODULE: ./src/modules/Taxes/selectors.ts







/**
 * Get all taxes organized per store
 */ const selectAllTaxesPerStore = (param)=>{
    let { taxes  } = param;
    return taxes;
};
/**
 * Check if all taxes are loaded
 */ const selectAreTaxesLoaded = (0,es/* createSelector */.P1)(selectAllTaxesPerStore, (taxesPerStore)=>!(0,lodash.isEmpty)(taxesPerStore) && (0,lodash.every)(taxesPerStore, (taxes)=>taxes.status === types/* Status.SUCCEEDED */.q.SUCCEEDED || taxes.status === types/* Status.FAILED */.q.FAILED));
/**
 * Get all taxes organised by tax name
 */ const selectAllTaxesInfo = (0,es/* createSelector */.P1)(selectAllTaxesPerStore, Preferences/* getSelectedStoresIds */.F, (taxesPerStore, storeIds)=>{
    const allTaxes = (0,lodash.reduce)(taxesPerStore, (globalTaxes, taxes, storeId)=>{
        if (!(storeIds === null || storeIds === void 0 ? void 0 : storeIds.includes(Number(storeId))) || taxes.status !== types/* Status.SUCCEEDED */.q.SUCCEEDED) {
            return globalTaxes;
        }
        (0,lodash.forEach)(taxes.entities, (tax)=>{
            const name = "".concat(tax.name).concat(tax.productType || "");
            if (!globalTaxes[name]) {
                globalTaxes[name] = tax;
            } else {
                const globalTax = globalTaxes[name];
                globalTaxes[name] = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, globalTax), {
                    salesExclTax: globalTax.salesExclTax + tax.salesExclTax,
                    salesInclTax: globalTax.salesInclTax + tax.salesInclTax,
                    vat: globalTax.vat + tax.vat
                });
            }
            return globalTaxes;
        });
        return globalTaxes;
    }, {});
    return Object.values(allTaxes).sort(compareTaxes);
});

;// CONCATENATED MODULE: ./src/modules/Taxes/index.ts
/**
 * Taxes module
 */ /* Actions */ 
/* Reducer */ 
/* Sagas */ 
/* Selectors */ 
/* Types */ 


/***/ })

}]);